import Magnet from "../../assets/magnet.png";
import Earth from "../../assets/earth.png";
import Bed from "../../assets/bed.png";
import "../styles/BioHome.css";

const BioHome = () => {
  return (
    <div className="mag-home">
      <div className="mag-home-container">
        <h1 className="mag-home-title">
          Descubra o que é o<br /> Biomagnetismo
        </h1>
        <h2 className="mag-home-subtitle">em 3 pontos</h2>
        <div className="mag-home-dash"></div>
        <div className="mag-home-steps">
          <div className="mag-home-step1">
            <img src={Magnet} width="80px"></img>
            <h4>1</h4>
            <p>
              O Biomagnetismo utiliza ímãs potentes para restabelecer o
              equilíbrio das céluas de órgãos e tecidos do corpo.
            </p>
          </div>
          <div className="mag-home-step2">
            <img src={Earth} width="90px"></img>
            <h4>2</h4>
            <p>
              O Biomagnetismo se apoia em comprovação científica internacional
              para tratar doenças físicas e emocionais.
            </p>
          </div>
          <div className="mag-home-step3">
            <img src={Bed} width="90px"></img>
            <h4>3</h4>
            <p>
              O Biomagnetismo é uma técnica indolor que atua diretamente na
              causa das disfunções, físicas e emocionais.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BioHome;
